import type {FunctionComponent} from 'react';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const AiLabelSection: FunctionComponent = () => {
	const {t} = useTranslation();

	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t('featureslandingpage_title_alwaysauthentic_standalone-web', {
							ns: 'features',
						})}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_ourtechdetectsaigencontent_standalone-web',
							{
								ns: 'features',
							},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					aspectRatio="912/824"
					sizes={{base: '100vw', md: '50vw'}}
					h={{base: '310px', md: '100%'}}
					src={'447d96cd6053d7e0d97c4aba13c843f4.png'}
					alt={'ai-label'}
					width={{base: '100%', md: '70%'}}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'ai-label'}}
					href="/features/ai-labelling"
				>
					{t('generic_action_learnmore_standalone-web', {
						ns: 'common',
					})}
				</LandingButtonLink>
			}
		/>
	);
};
